import axios, { AxiosError, AxiosResponse } from 'axios';
import { createSystemAlertFactory } from './systemMessages';
import { SoftAlertType } from './types';

type ShowAlertFn = (
  message: string | React.ReactNode,
  type?: SoftAlertType,
  duration?: number,
  systemType?: string
) => number;

let systemAlerts: ReturnType<typeof createSystemAlertFactory> | null = null;

export const setTimeoutAlertHandler = (fn: ShowAlertFn) => {
  systemAlerts = createSystemAlertFactory(fn);
};

const isTimeoutError = (error: AxiosError) => error?.code === 'ECONNABORTED' && error?.message?.includes('timeout');

export const registerTimeoutInterceptor = () => {
  return axios.interceptors.response.use(
    (response: AxiosResponse) => response,
    (error: AxiosError) => {
      if (isTimeoutError(error) && systemAlerts) {
        systemAlerts.showTimeoutError();
        window.umami?.track('timeout-error');
      }
      return Promise.reject(error);
    }
  );
};
